import {
  ClsPeticionAddUpdateAgrupador,
  ClsPeticionBorrarPresupuesto,
  ClsPeticionCatalogoPpto,
  ClsPeticionPresupuesto,
  ClsPeticionPresupuestoActualiza,
  ClsRespuestaCatalogoPpto,
  ClsRespuestaDetallePresupuesto,
  ClsRespuestaOrganizacion,
  ClsRespuestaPresupuesto,
  ClsRespuestaPresupuestos
} from '../core/models/peticiones/cls-pr-presupuestos';
import {GenericoService} from '../core/services/generico.service';
import {ClsUtil} from '../util/cls-util';
import {ClsConfig} from '../util/cls-config';
import {AppPresupuestosService} from '../core/services/app-presupuestos.service';
import {AppInfoService} from '../core/services/app-info.service';
import {EnumMCGenerales} from '../core/models/enum/enum-menu-contextual';
import {INeodataMenu} from '../core/models/interfaces/generico-interface';
import {ClsPeticionGenerarArchivoIntercambio, ClsPeticionPresupuestos} from '../core/models/peticiones/cls-pr-generico';
import {
  ClsPeticionCompartirPpto,
  ClsPeticionRespuestaBorrarUsuarioCompartirPpto,
  ClsRespuestaObtieneUsuarioCompartidosPpto
} from '../core/models/peticiones/cls-pr-recibir-archivo-intercambio';
import {ClsObjGenerico} from './util/cls-obj-generico';
import {VtnGenericaComponent} from '../componentes/util/ventanas/vtn-generica/vtn-generica.component';
import {
  CompartirPresupuestoComponent
} from '../componentes/util/ventanas/compartir-presupuesto/compartir-presupuesto.component';
import {EnvioIntercambioComponent} from '../componentes/util/ventanas/envio-intercambio/envio-intercambio.component';
import {EnumMasOpciones, EnumMIMETypes} from '../core/models/enum/enum-mas-opciones';
import {
  ClsCatalogoPresupuestos,
  ClsOrganizacion,
  ClsPresupuestos,
  ClsUsuarioCompartir
} from '../core/models/cls-presupuestos';
import {ClsAccessToken} from '../core/models/cls-access-token';
import {ClsErrores} from '../core/models/cls-errores';
import {inject} from "@angular/core";
import {CrearComponenteDinamicoService} from "../core/services/crear-componente-dinamico.service";
import { IgxGridComponent } from "@infragistics/igniteui-angular/grids/grid";

export class ClsObjCatalogoPresupuestosGenerales extends ClsConfig {
  public gridCatPptoGral: IgxGridComponent;
  // arreglos para filtrado
  public gridDataCompleta: ClsCatalogoPresupuestos[] = [];
  public gridDataFiltrada: ClsCatalogoPresupuestos[] = [];
  public dataCatPptoGral: ClsCatalogoPresupuestos[] = [];
// menu contextual
  private menus: INeodataMenu[] = [];

  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  constructor() {
    super();
  }

  public inicializarPresupuesto(): ClsPresupuestos {
    return {
      IdPresupuesto: BigInt('0'),
      IdEmpresaDeUsuario: this.infApp.usuarioLogeado.idEmpresa,
      IdOrganizacion: this.infPpto.organizacion.IdOrganizacion,
      IdUsuarioCreador: this.infApp.usuarioLogeado.idUsuario,
      EMailUsuarioCreador: this.infApp.usuarioLogeado.email,
      CodigoPresupuesto: '',
      NombrePresupuesto: '',
      Direccion: '',
      Colonia: '',
      IdEstado: BigInt('0'),
      IdCiudad: BigInt('0'),
      CodPost: '',
      Telefono: '',
      EMail: '',
      Observaciones: '',
      Bloqueado: false,
      IdResponsable: BigInt('0'),
      Cargo: '',
      IdEmpresa: BigInt('0'),
      IdCliente: BigInt('0'),
      IdVendedor: BigInt('0'),
      IdClienteContacto: BigInt('0'),
      PorcentajeIVA: 0.16,
      FechaUltimoUso: new Date(),
      RequiereCalcular: false,
      RequiereTotalizar: false,
      RequiereCalcularWBS: false,
      TipoPresupuesto: 1,
      FechaUltimaExportacion: undefined,
      IdTipoLicitacion: BigInt('0'),
      Region: ''
    };
  }

  public inicializarCatalogoPptoAgregarModificar(agregar: boolean, pptoEditando: ClsCatalogoPresupuestos, ppto: ClsPresupuestos): ClsCatalogoPresupuestos {
    return {
      IdOrganizacion: ppto.IdOrganizacion,
      RazonSocial: this.infPpto.organizacion.RazonSocial,
      IdPresupuesto: ppto.IdPresupuesto,
      IdUsuarioCreador: ppto.IdUsuarioCreador,
      EMailUsuarioCreador: ppto.EMailUsuarioCreador,
      CodigoPresupuesto: ppto.CodigoPresupuesto,
      NombrePresupuesto: ppto.NombrePresupuesto,
      NivelAcceso: agregar ? 0 : pptoEditando.NivelAcceso,
      FechaVigencia: agregar ? undefined : pptoEditando.FechaVigencia,
      FechaUltimaExportacion: ppto.FechaUltimaExportacion,
      TipoPresupuesto: ppto.TipoPresupuesto,
      PorcentajeSobrecosto: agregar ? 0 : pptoEditando.PorcentajeSobrecosto,
      CostoDirecto: agregar ? 0 : pptoEditando.CostoDirecto,
      PrecioDeVenta: agregar ? 0 : pptoEditando.PrecioDeVenta,
      IdCiudad: ppto.IdCiudad,
      Ciudad: agregar ? '' : pptoEditando.Ciudad,
      IdCliente: ppto.IdCliente,
      Cliente: agregar ? '' : pptoEditando.Cliente,
      FechaUltimoUso: ppto.FechaUltimoUso,
      PresupuestoAgrupador: agregar ? 1 : pptoEditando.PresupuestoAgrupador,
      UrlContenido: agregar ? '' : pptoEditando.UrlContenido
    };
  }

  public crearMenuContextual(esMaestro: boolean) {
    const subLayout: INeodataMenu[] = [
      {
        id: EnumMasOpciones.Ajustar,
        descripcion: 'MENUCONTEXTUAL.ALTO_FILA',
        icono: 'wrap_text',
        disabled: false,
        divisor: true
      },
      {
        id: EnumMCGenerales.GuardarLayout,
        descripcion: 'MENUCONTEXTUAL.GUARDAR_LAYOUT',
        icono: 'save',
        disabled: false,
        divisor: false
      },
      {
        id: EnumMCGenerales.ReestablecerLayout,
        descripcion: 'MENUCONTEXTUAL.RESTABLECER_LAYOUT',
        icono: 'restore',
        disabled: false,
        divisor: false
      }
    ];
    return this.menus = [
      {
        id: EnumMCGenerales.Abrir,
        descripcion: 'MENUCONTEXTUAL.ABRIR',
        icono: 'folder',
        disabled: false,
        divisor: false
      },
      {
        id: EnumMCGenerales.Detalle,
        descripcion: 'MENUCONTEXTUAL.DETALLE',
        icono: 'article',
        disabled: false,
        divisor: esMaestro
      },
      {
        id: EnumMCGenerales.Borrar,
        descripcion: 'MENUCONTEXTUAL.BORRAR',
        icono: 'delete',
        disabled: esMaestro,
        divisor: false
      },
      {
        id: EnumMCGenerales.Nuevo,
        descripcion: 'MENUCONTEXTUAL.NUEVO',
        icono: 'playlist_add',
        disabled: esMaestro,
        divisor: false
      },
      {
        id: EnumMCGenerales.Compartir,
        descripcion: 'MENUCONTEXTUAL.COMPARTIR',
        icono: 'share',
        disabled: esMaestro,
        divisor: false
      },
      {
        id: EnumMCGenerales.Respaldar,
        descripcion: 'MENUCONTEXTUAL.RESPALDAR',
        icono: 'cloud_upload',
        disabled: esMaestro,
        divisor: true
      },
      {
        id: '_layout',
        descripcion: 'MENUCONTEXTUAL.LAYOUT',
        icono: 'grid_on',
        disabled: false,
        divisor: true,
        subMenu: subLayout
      },
    ];
  }

  public async obtenerOrganizacion(): Promise<ClsOrganizacion> {
    let objRespuesta: ClsOrganizacion;
    const objPeticion: ClsAccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    try {
      objRespuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'OrganizacionRegistraActualiza2021');
      // modo offline
      if (!objRespuesta) {
        return null;
      }
      const resp2: ClsRespuestaOrganizacion = ClsUtil.parseJSONBig(objRespuesta);
      if (resp2?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp2.Errores.ErrorDescripcion);
      }

      return resp2.Organizacion;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerCatalogoPresupuestos(): Promise<ClsCatalogoPresupuestos[]> {
    let objRespuesta: ClsCatalogoPresupuestos[];
    const objPeticion: ClsPeticionCatalogoPpto = new ClsPeticionCatalogoPpto();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.TipoPresupuesto = this.infPpto.esPptoMaestro ? 2 : 1;
    try {
      objRespuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneListadoPresupuestosPropios');

      // modo offline
      if (!objRespuesta) {
        return [];
      }

      const pptos: ClsRespuestaCatalogoPpto = ClsUtil.parseJSONBig(objRespuesta);

      if (pptos?.Errores?.ErrorDescripcion !== '') {
        throw new Error(pptos.Errores.ErrorDescripcion);
      }


      // Procesamiento optimizado de la lista
      const listaPresupuestos = pptos.LsPresupuetos ?? [];
      // se le da formato fecha real(new Date())
      return listaPresupuestos.map(ppto => ({
        ...ppto,
        FechaVigencia: ClsUtil.convertirAFechaReal(ppto.FechaVigencia),
        FechaUltimaExportacion: ClsUtil.convertirAFechaReal(ppto.FechaUltimaExportacion),
        FechaUltimoUso: ClsUtil.convertirAFechaReal(ppto.FechaUltimoUso),
        // FechaLicitacion: new Date();
        PorcentajeSobrecosto: ClsUtil.convertPorcentaje(ppto.PorcentajeSobrecosto)
      }));
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerPptoSeleccionado(idPresupuesto: bigint, idOrganizacion: bigint): Promise<ClsRespuestaPresupuestos> {
    let respuesta: ClsRespuestaPresupuestos;
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    objPeticion.IdOrganizacion = idOrganizacion;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtienePresupuestoStoragev2');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp2: ClsRespuestaPresupuestos = ClsUtil.parseJSONBig(respuesta);
      if (resp2?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp2.Errores.ErrorDescripcion);
      }

      return resp2;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async presupuestoRegistra(ppto: ClsPresupuestos): Promise<ClsRespuestaPresupuesto> {
    let objRespuesta: ClsRespuestaPresupuesto;
    const objPeticion: ClsPeticionPresupuesto = new ClsPeticionPresupuesto();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.Presupuesto2021 = ppto;
    try {
      objRespuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'PresupuestoRegistraActualiza2021');
      // modo offline
      if (!objRespuesta) {
        return null;
      }

      const pptos: ClsRespuestaPresupuesto = ClsUtil.parseJSONBig(objRespuesta);

      if (pptos?.Errores?.ErrorDescripcion !== '') {
        throw new Error(pptos.Errores.ErrorDescripcion);
      }

      return pptos;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async presupuestoActualiza(ppto: ClsPresupuestos) {
    const objPeticion: ClsPeticionPresupuestoActualiza = new ClsPeticionPresupuestoActualiza();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = ppto.IdPresupuesto;
    objPeticion.CodigoPresupuesto = ppto.CodigoPresupuesto;
    objPeticion.NombrePresupuesto = ppto.NombrePresupuesto;
    objPeticion.IdCliente = ppto.IdCliente;
    objPeticion.IdEmpresa = ppto.IdEmpresa;
    objPeticion.Direccion = ppto.Direccion;
    objPeticion.Colonia = ppto.Colonia;
    objPeticion.IdCiudad = ppto.IdCiudad;
    objPeticion.CodPost = ppto.CodPost;
    objPeticion.Telefono = ppto.Telefono;
    objPeticion.EMail = ppto.EMail;
    objPeticion.Observaciones = ppto.Observaciones;
    objPeticion.IdResponsable = ppto.IdResponsable;
    objPeticion.Bloqueado = ppto.Bloqueado;
    objPeticion.PorcentajeIVA = ppto.PorcentajeIVA;
    objPeticion.Cargo = ppto.Cargo;
    objPeticion.IdVendedor = ppto.IdVendedor;
    objPeticion.IdClienteContacto = ppto.IdClienteContacto;
    objPeticion.IdTipoLicitacion = ppto.IdTipoLicitacion;
    objPeticion.TipoPresupuesto = ppto.TipoPresupuesto;
    objPeticion.FechaUltimaExportacion = ppto.FechaUltimaExportacion;
    objPeticion.Region = ppto.Region;
    try {
      const objRespuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ActualizaDetallePresupuesto');
      // modo offline
      if (!objRespuesta) {
        return null;
      }
      const pptos: ClsErrores = ClsUtil.parseJSONBig(objRespuesta);
      if (pptos?.ErrorDescripcion !== '') {
        throw new Error(pptos.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerDetallePresupuesto(idPresupuesto: bigint): Promise<ClsPresupuestos> {
    let objRespuesta: ClsPresupuestos;
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    try {
      objRespuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneDetallePresupuesto');
      // modo offline
      if (!objRespuesta) {
        return null;
      }
      const pptos: ClsRespuestaDetallePresupuesto = ClsUtil.parseJSONBig(objRespuesta);
      if (pptos?.Errores?.ErrorDescripcion !== '') {
        throw new Error(pptos.Errores.ErrorDescripcion);
      }
      return pptos.DetallePresupuesto;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async borrarPresupuesto(idPresupuesto: bigint, idOrganizacion: bigint) {
    const objPeticion: ClsPeticionBorrarPresupuesto = new ClsPeticionBorrarPresupuesto();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    objPeticion.IdOrganizacion = idOrganizacion;
    try {
      const objRespuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'EliminaPresupuestoCompleto2021');
      // modo offline
      if (!objRespuesta) {
        return;
      }
      const pptos: ClsErrores = ClsUtil.parseJSONBig(objRespuesta);
      if (pptos?.ErrorDescripcion !== '') {
        throw new Error(pptos.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async compartirPresupuesto(usuario: ClsUsuarioCompartir): Promise<bigint> {
    let respuesta: bigint;
    const objPeticion: ClsPeticionCompartirPpto = new ClsPeticionCompartirPpto();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuestoXUsuario = ClsUtil.bigintX(usuario.IdPresupuestoXUsuario);
    objPeticion.IdPresupuesto = ClsUtil.bigintX(usuario.IdPresupuesto);
    objPeticion.EmailUsuarioCompartido = usuario.EmailUsuarioCompartido;
    objPeticion.NivelAcceso = usuario.NivelAcceso;
    objPeticion.FechaVigencia = usuario.FechaVigencia;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'CompartirPresupuesto');
      // modo offline
      if (!respuesta) {
        return 0n;
      }
      const ppto: ClsPeticionRespuestaBorrarUsuarioCompartirPpto = ClsUtil.parseJSONBig(respuesta);
      if (ppto?.Errores?.ErrorDescripcion !== '') {
        throw new Error(ppto.Errores.ErrorDescripcion);
      }
      return ppto.IdPresupuestoXUsuario;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerUsuariosCompartidosPresupuesto(idPresupuesto: bigint): Promise<ClsUsuarioCompartir[]> {
    let respuesta: ClsUsuarioCompartir[];
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneUsuariosCompartidos');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const ppto: ClsRespuestaObtieneUsuarioCompartidosPpto = ClsUtil.parseJSONBig(respuesta);
      if (ppto?.Errores?.ErrorDescripcion !== '') {
        throw new Error(ppto.Errores.ErrorDescripcion);
      }

      return ppto.UsuariosCompartidos ?? []; // si es null/undefined devuelve []
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async borrarUsuariosCompartidosPresupuesto(idPresupuestoXUsuario: string) {
    const objPeticion: ClsPeticionRespuestaBorrarUsuarioCompartirPpto = new ClsPeticionRespuestaBorrarUsuarioCompartirPpto();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuestoXUsuario = ClsUtil.bigintX(idPresupuestoXUsuario);
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'EliminarUsuarioCompartido');
      // modo offline
      if (!resp) {
        return;
      }
      const ppto: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (ppto?.ErrorDescripcion !== '') {
        throw new Error(ppto.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async generarConsultaPresupuesto(idPresupuesto: bigint) {
  //   const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.IdPresupuesto = idPresupuesto;
  //   await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'GeneraJsonsConsulta')
  //     .then((resp: any) => {
  //       const ppto: ClsErrores = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (ppto.ErrorDescripcion !== '') {
  //           throw new Error(ppto.ErrorDescripcion);
  //         }
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  // }

  public async registraActualizaAgrupador(agrupador: string, numAgrupador: number, idPresupuesto: bigint) {
    const objPeticion: ClsPeticionAddUpdateAgrupador = new ClsPeticionAddUpdateAgrupador();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    objPeticion.Agrupador = agrupador;
    objPeticion.NumAgrupador = numAgrupador;
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraActualizaAgrupador');
      // modo offline
      if (!resp) {
        return;
      }
      const pptos: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (pptos?.ErrorDescripcion !== '') {
        throw new Error(pptos.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public enterBusCatPptoGral(buscar: string, buscarInicio: boolean) {
    try {
      this.gridCatPptoGral.data.push(...this.gridDataCompleta);
      this.gridDataCompleta = [];
      this.gridDataFiltrada = [];

      buscar = ClsUtil.quitarAcentos(buscar.trim());
      if (buscar === '') {
        this.gridCatPptoGral.data = this.dataCatPptoGral;
        return;
      }

      // Filtrar los datos
      this.gridCatPptoGral.data = this.gridCatPptoGral.data.filter((item: ClsCatalogoPresupuestos) => {
        if (ClsUtil.filtroGridMatchItem(item, ['RazonSocial', 'EMailUsuarioCreador', 'CodigoPresupuesto', 'NombrePresupuesto', 'Cliente', 'Ciudad'], buscarInicio, buscar)) {
          this.gridDataFiltrada.push(item);
          return true;
        } else {
          this.gridDataCompleta.push(item);
          return false;
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
    return this.gridDataFiltrada;
  }

  public highlightSearch(filtros: string[], valor: string) {
    filtros.forEach(filtro => {
      const startIndex: number = valor.indexOf(filtro);
      if (startIndex < 0) {
        return;
      }
      const matchingString = valor.substring(startIndex, startIndex + filtro.length);
      valor = valor.replace(matchingString, `<span class="neo-inline-highlight">${matchingString}</span>`);
    });
    return valor;
  }

  public async compartirPpto(ppto: ClsCatalogoPresupuestos) {
    try {
      if (ppto.PresupuestoAgrupador === 3) {
        throw new Error('MENSAJES.GRALS.PPTO_NO_PROPIOS');
      }
      const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
      vtnGenerico.queVtnEstaAbierta = 'CompartirPpto';
      const vtnCompartirPpto:CompartirPresupuestoComponent = vtnGenerico.crearComponente(CompartirPresupuestoComponent);
      vtnCompartirPpto.pptoSeleccionado = ppto;
      await vtnCompartirPpto.open();
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async respaldarPpto(ppto: ClsCatalogoPresupuestos, objGenerico: ClsObjGenerico, objCatalogoPptosGrals: ClsObjCatalogoPresupuestosGenerales, exportarQue: ClsPeticionGenerarArchivoIntercambio) {
    try {
      let vtnMensajeIntercambio: EnvioIntercambioComponent;
      const { archivo, siHayDatos } = await objGenerico.previoGenerarEnviarArchivoIntercambio(ppto, true, exportarQue);
      if (!siHayDatos) {
        throw new Error('MENSAJES.ALERT.NO_HAY_DATOS_RESPALDAR');
      }

      objGenerico.tipoMsg.cerrarMasMsgsCustomizado();
      vtnMensajeIntercambio = this.crearCompDinamico.crearComponente(EnvioIntercambioComponent).instance as EnvioIntercambioComponent;
      vtnMensajeIntercambio.alertMensaje = objCatalogoPptosGrals.getTranslationsAlertRespaldoOK(ppto.CodigoPresupuesto, this.infApp.usuarioLogeado.email);
      vtnMensajeIntercambio.formaQuestion = false;
      vtnMensajeIntercambio.siHayDatosRespaldar = true;
      vtnMensajeIntercambio.open();
      vtnMensajeIntercambio.respuesta.subscribe(chk => {
        if (chk) {
          ClsUtil.decargarArchivoBase64(archivo.ArchivoIntercambio, archivo.NombreArchivo, EnumMIMETypes.ZIP);
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  //#region Traduccion
  public getTranslationsTitulo(): string {
    const translations: any = ClsUtil.getTranslations(['TITULOS.CAT_GRAL', 'MENSAJES.GRALS.MAESTRO'], this.infApp);
    let mensaje: string = translations['TITULOS.CAT_GRAL'];
    mensaje = this.infPpto.esPptoMaestro ? mensaje.replace('{0}', ` ${translations['MENSAJES.GRALS.MAESTRO'].toString().toLowerCase()}`) : mensaje.replace('{0}', '');
    return mensaje;
  }

  public getTranslationsWaitCatalogo(): string {
    const translations = ClsUtil.getTranslations(['MENSAJES.WAIT.GETCATALOGO', 'MENSAJES.GRALS.MAESTRO'], this.infApp);
    let mensaje: string = translations['MENSAJES.WAIT.GETCATALOGO'];
    mensaje = this.infPpto.esPptoMaestro ? mensaje.replace('{0}', ` ${translations['MENSAJES.GRALS.MAESTRO'].toString().toLowerCase()}`) : mensaje.replace('{0}', '');
    return mensaje;
  }

  public getTranslationsWaitDetalleCatalogo(codigoPpto: string): string {
    return ClsUtil.getTranslations(['MENSAJES.WAIT.DETALLEPPTOCATALOGO'], this.infApp)['MENSAJES.WAIT.DETALLEPPTOCATALOGO'].toString().replace('{0}', codigoPpto);
  }

  public getTranslationsCrearModifPpto(accion: string, codigoPpto: string): string {
    return ClsUtil.getTranslations([accion], this.infApp)[accion].toString().replace('{0}', codigoPpto);
  }

  public getTranslationsWaitGuardarUsuariosCompartidos(correo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.WAIT.GUARDAR_USERS_COMPARTIDOS'], this.infApp)['MENSAJES.WAIT.GUARDAR_USERS_COMPARTIDOS'].toString().replace('{0}', correo);
  }

  public getTranslationsWaitActualizarUsuariosCompartidos(correo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.WAIT.ACTUALIZAR_USERS_COMPARTIDOS'], this.infApp)['MENSAJES.WAIT.ACTUALIZAR_USERS_COMPARTIDOS'].toString().replace('{0}', correo);
  }

  public getTranslationsWaitBorrarUsuariosCompartidos(correo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.WAIT.BORRAR_USERS_COMPARTIDO'], this.infApp)['MENSAJES.WAIT.BORRAR_USERS_COMPARTIDO'].toString().replace('{0}', correo);
  }

  // public getTranslationsToasGuardarUsuariosCompartidos(correo: string): string {
  //   return ClsUtil.getTranslations(['MENSAJES.TOAS.GUARDAR_USERS_COMPARTIDOS'], this.infApp)['MENSAJES.TOAS.GUARDAR_USERS_COMPARTIDOS'].toString().replace('{0}', correo);
  // }
  //
  // public getTranslationsToasActualizarUsuariosCompartidos(correo: string): string {
  //   return ClsUtil.getTranslations(['MENSAJES.TOAS.ACTUALIZAR_USERS_COMPARTIDOS'], this.infApp)['MENSAJES.TOAS.ACTUALIZAR_USERS_COMPARTIDOS'].toString().replace('{0}', correo);
  // }
  //
  // public getTranslationsToasBorrarUsuariosCompartidos(correo: string): string {
  //   return ClsUtil.getTranslations(['MENSAJES.TOAS.BORRAR_USERS_COMPARTIDO'], this.infApp)['MENSAJES.TOAS.BORRAR_USERS_COMPARTIDO'].toString().replace('{0}', correo);
  // }

  public getTranslationsQuestionRespaldoMailBorrar(ppto: string, correo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.RESPALDO_ENVIAR_BORRAR'], this.infApp)['MENSAJES.QUESTION.RESPALDO_ENVIAR_BORRAR'].toString().replace('{0}', ppto).replace('{1}', correo);
  }

  public getTranslationsQuestionRespaldoMailBorrar2(correo: string, codigoPpto: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.RESPALDO_ENVIAR_BORRAR_2'], this.infApp)['MENSAJES.QUESTION.RESPALDO_ENVIAR_BORRAR_2'].toString().replace('{0}', correo).replace('{1}', codigoPpto);
  }

  public getTranslationsAlertPptoExisteAbierto(codigoPpto: string): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.PPTO_ABIERTO'], this.infApp)['MENSAJES.ALERT.PPTO_ABIERTO'].toString().replace('{0}', codigoPpto);
  }

  public getTranslationsAlertRespaldoOK(codigoPpto: string, correo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.RESPALDO_OK'], this.infApp)['MENSAJES.ALERT.RESPALDO_OK'].toString().replace('{0}', codigoPpto).replace('{1}', correo);
  }

  public getTranslationsRowPinning(maxPinning: number): string {
    return ClsUtil.getTranslations(['MENSAJES.GRALS.#FILAS_ANCLADAS'], this.infApp)['MENSAJES.GRALS.#FILAS_ANCLADAS'].toString().replace('{0}', maxPinning);
  }

  public getTranslationsNivelAcceso(acceso: string): string {
    return ClsUtil.getTranslations([acceso], this.infApp)[acceso].toString();
  }

  //#endregion
}
